/** Skeleton do Funil — header + barra + colunas do kanban. */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-7xl animate-pulse flex-col gap-6">
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      <div className="flex items-center justify-between">
        <div className="h-4 w-32 rounded bg-slate-100" />
        <div className="h-9 w-36 rounded-xl bg-slate-200" />
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
        {[0, 1, 2, 3, 4, 5].map((c) => (
          <div key={c} className="rounded-2xl bg-slate-100 p-2.5">
            <div className="mb-2 h-3 w-20 rounded bg-slate-200" />
            <div className="flex flex-col gap-2">
              {[0, 1].map((i) => (
                <div key={i} className="h-24 rounded-xl bg-white" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
